import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"
import { toast } from "react-hot-toast"
import { 
  urlDrayageBookingService
} from "@src/endpoints"

const MySwal = withReactContent(Swal)

const getParamString = (params) => {
  let string = ""
  if (Object.keys(params).length > 0) {
    Object.keys(params).map((key) => {
      if (params[key] !== null && params[key] !== undefined && params[key] !== "") {
        string += `${key}=${params[key]}&`
      }
    })
  }
  return string
}

// Get all drayage bookings
export const getDrayageData = createAsyncThunk(
  "drayageBooking/getDrayageData",
  async (params) => {
    try {
      const response = await axios.post(
        `${urlDrayageBookingService}/GetAllDrayageBooking?${getParamString(
          params.params
        )}`,
        params.filter || {}
      )      
      return { ...response.data, ...params }
    } catch (error) {
      const errMsg = error.response?.data?.errors?.[0] || error.message || "An error occurred"
      MySwal.fire({ icon: "error", title: "Error", text: errMsg })
      return { success: false, message: errMsg }
    }
  }
)

// Update drayage booking
export const updateDrayageBooking = createAsyncThunk(
  "drayageBooking/updateDrayageBooking",
  async (data) => {
    try {
      const response = await axios.put(
        `${urlDrayageBookingService}/UpdateDrayageBooking`,
        data
      )
      if (response.data.success) {
        // toast.success("Drayage Booking Updated!!")
        return response.data
      } else {
        toast.error(response.data.errors[0])
        return response.data
      }
    } catch (error) {
      const errMsg = error.response?.data?.errors?.[0] || error.message || "An error occurred"
      MySwal.fire({ icon: "error", title: "Error", text: errMsg })
      return { success: false, message: errMsg }
    }
  }
)

// Delete drayage booking
export const deleteDrayageBooking = createAsyncThunk(
  "drayageBooking/deleteDrayageBooking",
  async (id) => {
    try {
      const response = await axios.delete(
        `${urlDrayageBookingService}/DeleteDrayageBooking/${id}`
      )
      if (response.data.success) {
        toast.success("Drayage Booking Deleted!!")
        return { success: true }
      } else {
        toast.error(response.data.errors[0])
        return { success: false, message: response.data.errors[0] }
      }
    } catch (error) {
      const errMsg = error.response?.data?.errors?.[0] || error.message || "An error occurred"
      MySwal.fire({ icon: "error", title: "Error", text: errMsg })
      return { success: false, message: errMsg }
    }
  }
)

//Add drayage booking
export const addDrayageBooking = createAsyncThunk(
    "drayageBooking/addDrayageBooking",
    async (data) => {
      try {
        const response = await axios.post(
          `${urlDrayageBookingService}/AddDrayageBooking`,
          data
        )
        if (response.data.success) {
          // toast.success("Drayage Booking Added!!")
          return response.data
        } else {
          toast.error(response.data.errors[0])
          return response.data
        }
      } catch (error) {
        const errMsg = error.response?.data?.errors?.[0] || error.message || "An error occurred"
        MySwal.fire({ icon: "error", title: "Error", text: errMsg })
        return { success: false, message: errMsg }
      }
    }
)

//GET - /GetDrayageBookingStatusCount
export const getDrayageBookingStatusCount = createAsyncThunk(
  "drayageBooking/getDrayageBookingStatusCount",
  async () => {
    // console.log("Fetching Drayage Booking Status Count")
    try {
      const response = await axios.get(
        `${urlDrayageBookingService}/GetDrayageBookingStatusCount`
      )
      if (response.data.success) {
        return response.data
      } else {
        const errMsg = response.data.errors[0] || "An error occurred"
        MySwal.fire({ icon: "error", title: "Error", text: errMsg })
        return { success: false, message: errMsg }
      }
    } catch (error) {
      const errMsg = error.response?.data?.errors?.[0] || error.message || "An error occurred"
      MySwal.fire({ icon: "error", title: "Error", text: errMsg })
      return { success: false, message: errMsg }
    }
  }
)

export const drayageBookingSlice = createSlice({
  name: "drayageBooking",
  initialState: {
    drayageData: [],
    drayageId: null,
    total: 0,
    loaded: true,
    stats:{
      created: 0,
      inProgress: 0,
      completed: 0
    }
  },
  reducers: {
    resetId: (state) => {
      state.drayageId = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDrayageData.fulfilled, (state, action) => {
        // if (action.payload.success) {
          state.drayageData = action.payload.data
          state.total = action.payload.totalCount
        // }
        state.loaded = true
      })
      .addCase(getDrayageData.pending, (state) => {
        state.loaded = false
      })
      .addCase(getDrayageData.rejected, (state) => {
        state.loaded = true
      })
      .addCase(updateDrayageBooking.fulfilled, () => {
        // Don't update the state here - let the parent component refresh the data
        // This ensures we get the latest data with proper pagination and filtering
      })
      .addCase(deleteDrayageBooking.fulfilled, (state, action) => {
        // Decrement total count when deletion is successful
        if (action.payload?.success && state.total > 0) {
          state.total -= 1
        }
      })
      .addCase(addDrayageBooking.fulfilled, () => {
        // Don't update the state here - let the parent component refresh the data
        // This ensures we get the latest data with proper pagination and filtering
      })
       //addDrayageBooking rejected case
      .addCase(addDrayageBooking.rejected, (state, action) => {
            // Handle the case where adding a booking fails
            const errMsg = action.error.message || "An error occurred while adding the booking"
            MySwal.fire({ icon: "error", title: "Error", text: errMsg })
            return { ...state, loaded: true }
        })   
      .addCase(getDrayageBookingStatusCount.fulfilled, (state, action) => {
        if (action.payload.success) {
          state.stats = {
            created: action.payload.data.created,
            inProgress: action.payload.data.inProgress,
            completed: action.payload.data.completed,
            assigned: action.payload.data.assigned || 0 // Ensure assigned is set, default to 0 if not present
          }
        } else {
          state.stats = {
            created: 0,
            inProgress: 0,
            completed: 0,
            assigned: 0 // Default to 0 if fetching fails
          }
        }
      })
      //any pending action will set loaded to false
        .addMatcher(
          (action) => action.type.endsWith('/pending'),
          (state) => {
            state.loaded = false
          }
        )
      //any rejected action will set loaded to true
        .addMatcher(
          (action) => action.type.endsWith('/rejected'),
          (state) => {
            state.loaded = true
          }
        )
        //fulfilled action will set loaded to true
        .addMatcher(
          (action) => action.type.endsWith('/fulfilled'),
          (state) => {
            state.loaded = true
          }
        )
  }
})

export const { resetId } = drayageBookingSlice.actions

export default drayageBookingSlice.reducer